import dayjs from "dayjs";

interface CameraDailyCacheEntry<T> {
  data: T;
  fetchedDate: string;
  requestedDay: string;
}

const DATE_FORMAT = "YYYY-MM-DD";

const getDateFromTimestamp = (timestamp: string): string => {
  return dayjs(timestamp).utc().format(DATE_FORMAT);
};

const getTodayUTC = (): string => {
  return dayjs().utc().format(DATE_FORMAT);
};

const getCacheKey = (cacheKeyPrefix: string, timestamp: string): string => {
  const requestedDay = getDateFromTimestamp(timestamp);
  return `${cacheKeyPrefix}:${requestedDay}`;
};

export const createCameraDailyCache = <T>(cacheKeyPrefix: string) => {
  const clearExpiredCache = (): void => {
    const todayUTC = getTodayUTC();

    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(cacheKeyPrefix)) {
        const cacheEntry: CameraDailyCacheEntry<T> = JSON.parse(
          localStorage.getItem(key) || "{}"
        );

        if (cacheEntry.fetchedDate < todayUTC) {
          localStorage.removeItem(key);
        }
      }
    });
  };

  const get = (timestamp: string): T | null => {
    const cacheKey = getCacheKey(cacheKeyPrefix, timestamp);

    const cachedData = localStorage.getItem(cacheKey);

    if (cachedData) {
      const { data } = JSON.parse(cachedData) as CameraDailyCacheEntry<T>;
      return data;
    }

    return null;
  };

  const set = (requestTimestamp: string, data: T): void => {
    const cacheKey = getCacheKey(cacheKeyPrefix, requestTimestamp);
    const cacheEntry: CameraDailyCacheEntry<T> = {
      data,
      fetchedDate: getTodayUTC(),
      requestedDay: getDateFromTimestamp(requestTimestamp),
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
  };

  return {
    clearExpiredCache,
    get,
    set,
  };
};
